import { Component, OnInit, ViewChild } from '@angular/core';
import { first, firstValueFrom } from 'rxjs';
import { Import } from 'src/app/models/import.model';
import { ImportErrorsComponent } from '../import-errors/import-errors.component';
import * as moment from 'moment';
import { orderBy } from 'lodash';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorHandlerService } from '@aveva/connect-web-core';
import { MediaObserver } from '@angular/flex-layout';
import { ImportsService } from 'src/app/services/imports.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as globals from '../../globals';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-import-students',
  templateUrl: './import-students.component.html',
  styleUrls: ['./import-students.component.scss']
})
export class ImportStudentsComponent implements OnInit {
  constructor(
    private errorHandler: ErrorHandlerService,
    private importsService: ImportsService,
    public dialog: MatDialog,
    public media: MediaObserver,
    private snackBar: MatSnackBar,
    private logger: LoggingService) { }

  ngOnInit() {
    try {
      this.getImports();
      this.fileReader.addEventListener('load', (event: any) => {
        this.uploadFile();
      }, false);
    }
    catch { }
    this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));
  }

  fileSelected(files: FileList) {
    try {
      this.isLoading = true;
      const file = files[0];

      if(file === undefined || file === null) {
        this.isLoading = false;
        return;
      }

      this.fileTooLarge = file.size > this.MAX_SIZE;

      if (this.fileTooLarge) {
        this.isLoading = false;
        return;
      }
      
      this.filename = file.name;
      this.fileReader.readAsDataURL(file);
      this.isLoading = false;
    }
    catch (exception) {
      this.logger.logException(exception);
      this.isLoading = false;
    }
  }

  private uploadFile() {
    this.isLoading = true;
    try {
      const data = {
        filename: this.filename,
        import_data: (this.fileReader.result as string)
      };
      this.logger.logEvent('Import Upload Initiated', {fileName: this.filename});
      this.importsService.createImport(data).subscribe({
        next: (result) => {
          if(result) {
            this.getImports();
            setTimeout(() => this.getImports(), (10 * 1000));
            this.isLoading = false;
          }
          else {
            this.showMessage(globals.importFileError);
            this.isLoading = false;
          }
        },
        error: (e) => {
          this.logger.logException(e);          
          this.isLoading = false;
        }
      });
    } catch (error) {
      let localizationKey: string;
      if (error.status === 400) {
        localizationKey = 'importUploadFormat';
      }
      this.isLoading = false;
      return this.errorHandler.handle(error, localizationKey);
    }
  }

  private viewImportErrors(importId: number) {
    this.dialogRef = this.dialog.open(ImportErrorsComponent, {
      data: {
        importId: importId
      },
      width: '800px'
    });
    return firstValueFrom(this.dialogRef.afterClosed()
      .pipe(first()));
  }

  private getImports() {
    this.isLoading = true;
    try {
      this.importsService.queryImports().subscribe({
        next: (data) => {
          const imports: Import[] = orderBy(data, importItem => moment.utc(importItem.timestamp), ['desc']);
          this.dataSource = new MatTableDataSource(imports);
          setTimeout(() => this.isLoading = false, 500); 
        }
      });
    } catch (error) {
      this.logger.logException(error);
      this.isLoading = false;
      return this.errorHandler.handle(error);
    }
  }

  private showMessage = (message: string) => this.snackBar.open(message, null, { duration: 5000 });

  isContributor: boolean;
  dataSource = new MatTableDataSource<Import>();
  isLoading: boolean;

  fileTooLarge = false;
  private fileReader: FileReader = new FileReader();
  private filename;
  private readonly MAX_SIZE = 300000; // 300kB
  dialogRef: MatDialogRef<ImportErrorsComponent>;
  displayedColumns: string[] = globals.imports_columns;
  
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
}
